"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStylesParam = exports.createStylesParams = void 0;
var tslib_1 = require("tslib");
function createStylesParams(styles) {
    return Object.keys(styles).reduce(function (acc, key) {
        acc[key] = tslib_1.__assign(tslib_1.__assign({}, styles[key]), { key: styles[key].key || key });
        return acc;
    }, {});
}
exports.createStylesParams = createStylesParams;
exports.createStylesParam = function (key, param) { return (tslib_1.__assign({ key: key }, param)); };
//# sourceMappingURL=createStylesParams.js.map